
import React from 'react';
import { PackageOpen } from 'lucide-react';

const MaterialStatus = ({ materials }) => {
    return (
        <div className="bg-white rounded-2xl p-4 shadow-md h-full">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Material Status</h3>

            <div className="flex flex-col gap-3 mb-4">
                  {materials?.length ? materials.map((item, index) => (
                    <div key={index} className="flex flex-col">
                        <div className="flex items-center gap-2 mb-0.5">
                            {/* Status Dot */}
                            <div className={`w-2 h-2 rounded-full flex-shrink-0 ${item.status === 'Available' ? 'bg-[#1F4B55]' :
                                item.status === 'Critical' ? 'bg-[#FF7676]' : 'bg-[#E3C86F]'
                                }`}></div>
                            <span className="text-sm text-gray-900 leading-none font-medium">{item.itemName}</span>
                        </div>
                        <div className="text-xs text-gray-500 pl-4 font-normal">Used Stock: <span className="text-gray-600 font-medium">{item.used ?? 0} {item.unit ? ` ${item.unit}` : ''}</span></div>
                    </div>
                )) : (
                    <div className="flex flex-col items-center justify-center py-6 px-4 text-center">
                        <PackageOpen className="w-10 h-10 text-gray-300 mb-2" strokeWidth={1.25} aria-hidden />
                        <p className="text-sm text-gray-500">No materials were used for this date.</p>
                    </div>
                )}
            </div>

            {/* Legend */}
            <div className="flex items-center gap-3 text-[10px] text-gray-600 pt-3 border-t border-gray-100">
                <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#1F4B55]"></span>
                    Available
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#E3C86F]"></span>
                    Low
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FF7676]"></span>
                    Critical
                </div>
            </div>
        </div>
    );
};

export default MaterialStatus;
